<!--The content below is only a placeholder and can be replaced.-->
<gea-mes-header *ngIf="showNavBar" 

showLogOut="desktop"
showMenu="both"
showLeftIcon1="both"
leftIcon1ToolTip="Home Page"
LeftIcon1Src="apps"
routeLeftIcon1="apps"
>
</gea-mes-header>
<app-spinner></app-spinner>
<router-outlet></router-outlet>
